<template>
  <tour location="bottom right" title="Добавлены новые параметры">
    <template #text>
      Для запуска продаж проверьте:
      <ul class="ul-list my-2">
        <li>Актуальность/заполненность цен в&nbsp;шахматке по&nbsp;вариантам размещения / категориям номеров</li>
        <li>Заполненность квоты по категориям номеров</li>
        <li>Отправлен ли тариф на&nbsp;модерацию (в&nbsp;случае, если тариф еще не&nbsp;в&nbsp;продаже)</li>
      </ul>
      Если остались вопросы, обратитесь в
      <router-link :to="{ name: RouteNames.Support }" class="link">Поддержку</router-link>
    </template>
  </tour>
</template>

<script setup lang="ts">
import Tour from '@/core/components/common/Tour.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
</script>

<style scoped lang="scss"></style>
